import { cn } from "@/utils/cn";
import { memo } from "react";

interface ChevronDownIconProps {
  className?: string;
  strokeWidth?: number;
}

export const ChevronDownIcon = memo(function ChevronDownIcon({
  className,
  strokeWidth = 2,
}: ChevronDownIconProps) {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("stroke-[#620ad5]", className)}
    >
      <path
        d="M14 18L22.5 26L31 18"
        strokeWidth={strokeWidth}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
});
